import { HOME_TITLE } from 'environment';

const enUS = {
  'period:to': 'to',
  'period:calc': 'calculating ...',
  'commom:remove': 'Remover',
  'common:return': 'Retorno',

  'chart:resetZoom': 'Cancelar zoom',
  'chart:desktop:zoom': 'Clique e arraste na área do gráfico para aumentar o zoom',
  'chart:mobile:zoom': 'Utilize 2 dedos para dar zoom',

  'molecules:TitleHome:Title:title-1': HOME_TITLE || 'Comparador de ativos OUI Investimentos,',
  'molecules:TitleHome:Title:title-2': 'mais que fundos de investimentos',
  'molecules:ThirdHeader:benchmark': 'Benchmark',
  'molecules:ThirdHeader:periodo': 'Período',
  'molecules:ThirdHeader:aplicaoInicial': 'Aplicação Inicial',
  'molecules:ActiveBox:cancelar': 'Cancelar',
  'molecules:ActiveBox:selecionar': 'Selecionar',
  'molecules:Modals:SerieModal:alert':'Alguns ativos não serão exibidos no gráfico pois não possuem série histórica em todo esse período.',
  'molecules:Modals:MobileFooter:close': 'Fechar',
  'molecules:Card:asset': 'Ativo',

  'organisms:SearchAssets:searchString': 'Buscar ativos por nome, cnpj ou ticker',
  'organisms:SelectedActives:title': 'Ativos selecionados',
  'organisms:SearchAssets:cnpj': 'CNPJ',
  'organisms:SearchAssets:nenhumResultadoEncontrado': 'Nenhum resultado encontrado',
  'organisms:OverlayRow:remover': 'Remover',
  
  'pages:HomePage:ClearActives': 'Limpar todos',
  'pages:HomePage:AnalysisButton': 'Iniciar análise dos ativos selecionados ',
  'pages:HomePage:AnalysisButton:mobile': 'Iniciar análise dos ativos',
  'table:Header:Indicators': 'Indicadores no período selecionado',
  'table:Header:ReturnHistory': 'Histórico de Retorno',

  'tabs:Rentability': 'Rentabilidade',
  'tabs:Return': 'Retorno',
  'tabs:Underwater': 'Underwater',

  'month:0': 'Jan',
  'month:1': 'Fev',
  'month:2': 'Mar',
  'month:3': 'Abr',
  'month:4': 'Mai',
  'month:5': 'Jun',
  'month:6': 'Jul',
  'month:7': 'Ago',
  'month:8': 'Set',
  'month:9': 'Out',
  'month:10': 'Nov',
  'month:11': 'Dec',

  'period:UM_MES': '1 mês',
  'period:SEIS_MESES': '6 meses',
  'period:UM_ANO': '1 ano',
  'period:CINCO_ANOS': '5 anos',

  'measure:RENTABILIDADE': 'Rentabilidade',
  'measure:PATRIMONIO_LIQUIDO': 'PL. Milhões',
  'measure:SHARPE': 'Sharpe',
  'measure:TAXA_DE_ADMINISTRACAO': 'Taxa de admin',
  'measure:VOLATILIDADE': 'Volatilidade',
  'measure:RETORNO': 'Retorno',
  'measure:RETORNO_UM_ANO': 'Retorno 1 ano',
  'measure:RETORNO_YTD': 'Retorno YTD',
  'measure:DRAW_DOWN': 'Draw Down',
  'measure:INICIO_DO_1_DRAW_DOWN': 'Iní. Max. D. D',
  'measure:DATA_DO_1_DRAW_DOWN': 'Data Max. D.D',
  'measure:PRIMEIRO_DRAW_DOWN': 'Máx. D.D',

  'assetType:FI': 'FI',
  'assetType:FII': 'FII',
  'assetType:EUROPA': '', // FIXME: Produtos vai passar o label correto futuramente.
  'assetType:ACAO': 'Ação',
  'assetType:RENDA_FIXA': 'Renda Fixa',
  'assetType:EMPRESA_ABERTA': 'Empresa Aberta',
}

export default enUS
